export default __webpack_public_path__ + "static/media/pet_placeholder.d8894680.png";